import React, { useState, useEffect } from "react";
import { useColors } from "../../../contexts/ColorContext";
import { Card, Form, Button, Table, Alert, Modal } from "react-bootstrap";
import api from "../../../services/api";

export default function Horarios({ usuario }) {
  const { colors } = useColors();
  const { primaryColor, secondaryColor, cardBackgroundColor, cardTextColor, buttonColor, buttonTextColor } = colors;
  const [horarios, setHorarios] = useState([]);
  const [bloqueios, setBloqueios] = useState([]);
  const [showHorarioModal, setShowHorarioModal] = useState(false);
  const [showBloqueioModal, setShowBloqueioModal] = useState(false);
  const [formHorario, setFormHorario] = useState({
    id: null,
    tipo: "Padrao",
    diaSemana: "1",
    horaInicio: "",
    horaFim: "",
    dataEspecifica: "",
  });
  const [formBloqueio, setFormBloqueio] = useState({
    id: null,
    dataInicio: "",
    dataFim: "",
    horaInicio: "",
    horaFim: "",
    diaTodo: false,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const diasSemana = [
    "Domingo",
    "Segunda",
    "Terça",
    "Quarta",
    "Quinta",
    "Sexta",
    "Sábado",
  ];

  // 🔹 Buscar horários e bloqueios
  const fetchHorarios = async () => {
    if (!usuario?.id) return;
    setLoading(true);
    try {
      const response = await api.get(`/Horarios/funcionario/${usuario.id}`);
      setHorarios(response.data.disponibilidades || []);
      setBloqueios(response.data.bloqueios || []);
      setError(null);
    } catch (err) {
      console.error("Erro ao carregar horários:", err);
      setError("Erro ao carregar horários.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchHorarios();
  }, [usuario]);

  // 🔹 Controle dos inputs
  const handleHorarioChange = (e) => {
    const { name, value } = e.target;
    setFormHorario((prev) => ({ ...prev, [name]: value }));
  };

  const handleBloqueioChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormBloqueio((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // 🔹 Abrir modal de edição
  const handleEditHorario = (horario) => {
    setFormHorario({
      id: horario.id,
      tipo: horario.tipo,
      diaSemana: horario.diaSemana?.toString() || "1",
      horaInicio: horario.horaInicio?.substring(0, 5),
      horaFim: horario.horaFim?.substring(0, 5),
      dataEspecifica: horario.dataEspecifica
        ? horario.dataEspecifica.split("T")[0]
        : "",
    });
    setShowHorarioModal(true);
  };

  const handleEditBloqueio = (bloqueio) => {
    setFormBloqueio({
      id: bloqueio.id,
      dataInicio: bloqueio.data.split("T")[0],
      dataFim: bloqueio.data.split("T")[0],
      horaInicio: bloqueio.horaInicio?.substring(0, 5),
      horaFim: bloqueio.horaFim?.substring(0, 5),
      diaTodo:
        bloqueio.horaInicio === "00:00:00" && bloqueio.horaFim === "23:59:59",
    });
    setShowBloqueioModal(true);
  };

  // 🔹 Salvar horário (novo ou edição)
  const handleHorarioSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        funcionarioId: usuario.id,
        diaSemana:
          formHorario.tipo === "Padrao"
            ? parseInt(formHorario.diaSemana)
            : null,
        dataEspecifica:
          formHorario.tipo === "Excecao" ? formHorario.dataEspecifica : null,
        horaInicio: formHorario.horaInicio + ":00",
        horaFim: formHorario.horaFim + ":00",
        tipo: formHorario.tipo,
      };

      if (formHorario.id) {
        await api.put(`/Horarios/disponibilidade/${formHorario.id}`, payload);
      } else {
        await api.post("/Horarios/disponibilidade", payload);
      }

      setShowHorarioModal(false);
      fetchHorarios();
    } catch (err) {
      window.globalAlert("Erro ao salvar horário.", "error");
      console.error(err);
    }
  };

  // 🔹 Salvar bloqueio (novo ou edição)
  // 🔹 POST bloqueio (com opção de recorrente)
const handleBloqueioSubmit = async (e) => {
  e.preventDefault();
  try {
    const funcionario = await api.get(`/Funcionarios/${usuario.id}`);
    const clienteMasterId = funcionario.data.clienteMasterId;

    const {
      dataInicio,
      dataFim,
      horaInicio,
      horaFim,
      diaTodo,
      recorrente,
      diaSemana,
      mes,
    } = formBloqueio;

    if (recorrente) {
      // 🔸 Gera todos os dias do mês escolhido que caem no dia da semana selecionado
      const ano = new Date().getFullYear();
      const primeiroDia = new Date(ano, mes - 1, 1);
      const ultimoDia = new Date(ano, mes, 0);

      const dias = [];
      for (let d = new Date(primeiroDia); d <= ultimoDia; d.setDate(d.getDate() + 1)) {
        if (d.getDay() === parseInt(diaSemana)) {
          dias.push(new Date(d));
        }
      }

      for (const dia of dias) {
        const payload = {
          clienteMasterId,
          funcionarioId: usuario.id,
          data: new Date(dia),
          horaInicio: diaTodo ? "00:00:00" : horaInicio + ":00",
          horaFim: diaTodo ? "23:59:59" : horaFim + ":00",
        };
        await api.post("/Horarios/bloqueio", payload);
      }

      window.globalAlert(`Bloqueio aplicado para todas as ${diasSemana[diaSemana]}s de ${new Date(ano, mes - 1).toLocaleString("pt-BR", { month: "long" })}!`, "success");
    } else {
      // 🔸 Bloqueio normal (intervalo de datas)
      const inicio = new Date(dataInicio);
      const fim = new Date(dataFim || dataInicio);

      const dias = [];
      for (let d = new Date(inicio); d <= fim; d.setDate(d.getDate() + 1)) {
        dias.push(new Date(d));
      }

      for (const dia of dias) {
        const payload = {
          clienteMasterId,
          funcionarioId: usuario.id,
          data: new Date(dia),
          horaInicio: diaTodo ? "00:00:00" : horaInicio + ":00",
          horaFim: diaTodo ? "23:59:59" : horaFim + ":00",
        };
        await api.post("/Horarios/bloqueio", payload);
      }

      window.globalAlert("Bloqueio(s) adicionado(s) com sucesso!", "success");
    }

    setShowBloqueioModal(false);
    fetchHorarios();
  } catch (err) {
    window.globalAlert("Erro ao adicionar bloqueio.", "error");
    console.error(err);
  }
};


  // 🔹 Excluir
const handleDeleteHorario = async (id) => {
  await api.delete(`/Horarios/disponibilidade/${id}`);
  fetchHorarios();
};

const handleDeleteBloqueio = async (id) => {
  await api.delete(`/Horarios/bloqueio/${id}`);
  fetchHorarios();
};

  return (
    <div className="d-flex justify-content-center align-items-start w-100">
      <Card className="p-4 shadow-sm w-100" style={{ backgroundColor: cardBackgroundColor, color: cardTextColor }}>
        <h5>Gerenciar Horários e Bloqueios</h5>

        <div className="d-flex justify-content-end mb-3 gap-2">
          <Button
            variant="success"
            style={{ backgroundColor: buttonColor, borderColor: buttonColor, color: buttonTextColor }}
            onClick={() => {
              setFormHorario({
                id: null,
                tipo: "Padrao",
                diaSemana: "1",
                horaInicio: "",
                horaFim: "",
                dataEspecifica: "",
              });
              setShowHorarioModal(true);
            }}
          >
            + Novo Horário
          </Button>
          <Button
            variant="warning"
            style={{ backgroundColor: secondaryColor, borderColor: secondaryColor, color: buttonTextColor }}
            onClick={() => {
              setFormBloqueio({
                id: null,
                dataInicio: "",
                dataFim: "",
                horaInicio: "",
                horaFim: "",
                diaTodo: false,
              });
              setShowBloqueioModal(true);
            }}
          >
            + Novo Bloqueio
          </Button>
        </div>

        {error && <Alert variant="danger">{error}</Alert>}
        {loading ? (
          <p>Carregando...</p>
        ) : (
          <>
            {/* 🔹 Tabela de horários */}
            <h6>Horários Cadastrados</h6>
            <Table striped bordered hover responsive style={{ color: cardTextColor, borderColor: primaryColor }}>
              <thead>
                <tr>
                  <th>Tipo</th>
                  <th>Dia/Data</th>
                  <th>Início</th>
                  <th>Fim</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {horarios.length > 0 ? (
                  horarios.map((h) => (
                    <tr key={h.id}>
                      <td>{h.tipo || "Padrão"}</td>
                      <td>
                        {h.tipo === "Padrao"
                          ? diasSemana[h.diaSemana ?? 0]
                          : new Date(h.dataEspecifica || h.data).toLocaleDateString("pt-BR")}
                      </td>
                      <td>{h.horaInicio?.substring(0, 5)}</td>
                      <td>{h.horaFim?.substring(0, 5)}</td>
                      <td className="d-flex gap-2">
                        <Button
	                          size="sm"
	                          variant="primary"
	                          onClick={() => handleEditHorario(h)}
	                          style={{ backgroundColor: primaryColor, borderColor: primaryColor, color: buttonTextColor }}
	                        >
                          Editar
                        </Button>
                        <Button
	                          size="sm"
	                          variant="danger"
	                          onClick={() => handleDeleteHorario(h.id)}
	                          style={{ backgroundColor: primaryColor, borderColor: primaryColor, color: buttonTextColor }}
	                        >
                          Excluir
                        </Button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center">
                      Nenhum horário cadastrado.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>

            {/* 🔹 Tabela de bloqueios */}
            <h6>Bloqueios</h6>
            <Table striped bordered hover responsive style={{ color: cardTextColor, borderColor: primaryColor }}>
              <thead>
                <tr>
                  <th>Data</th>
                  <th>Início</th>
                  <th>Fim</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {bloqueios.length > 0 ? (
                  bloqueios.map((b) => (
                    <tr key={b.id}>
                      <td>{new Date(b.data).toLocaleDateString("pt-BR")}</td>
                      <td>{b.horaInicio?.substring(0, 5)}</td>
                      <td>{b.horaFim?.substring(0, 5)}</td>
                      <td className="d-flex gap-2">
                        <Button
                          size="sm"
                          variant="primary"
                          onClick={() => handleEditBloqueio(b)}
                        >
                          Editar
                        </Button>
                        <Button
                          size="sm"
                          variant="danger"
                          onClick={() => handleDeleteBloqueio(b.id)}
                        >
                          Excluir
                        </Button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center">
                      Nenhum bloqueio cadastrado.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </>
        )}
      </Card>

      {/* 🔹 Modal Horário */}
      <Modal
        show={showHorarioModal}
        onHide={() => setShowHorarioModal(false)}
        centered
      >
	        <Modal.Header closeButton style={{ backgroundColor: primaryColor, color: buttonTextColor }}>
	          <Modal.Title style={{ color: buttonTextColor }}>
	            {formHorario.id ? "Editar Horário" : "Novo Horário"}
	          </Modal.Title>
	        </Modal.Header>
	        <Modal.Body style={{ backgroundColor: cardBackgroundColor, color: cardTextColor }}>
          <Form onSubmit={handleHorarioSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Tipo</Form.Label>
              <Form.Select
                name="tipo"
                value={formHorario.tipo}
                onChange={handleHorarioChange}
              >
                <option value="Padrao">Padrão</option>
                <option value="Excecao">Extra</option>
              </Form.Select>
            </Form.Group>

            {formHorario.tipo === "Padrao" ? (
              <Form.Group className="mb-3">
                <Form.Label>Dia da Semana</Form.Label>
                <Form.Select
                  name="diaSemana"
                  value={formHorario.diaSemana}
                  onChange={handleHorarioChange}
                >
                  {diasSemana.map((d, i) => (
                    <option key={i} value={i}>
                      {d}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            ) : (
              <Form.Group className="mb-3">
                <Form.Label>Data Específica</Form.Label>
                <Form.Control
                  type="date"
                  name="dataEspecifica"
                  value={formHorario.dataEspecifica}
                  onChange={handleHorarioChange}
                />
              </Form.Group>
            )}

            <div className="d-flex gap-3">
              <Form.Group className="flex-grow-1">
                <Form.Label>Hora Início</Form.Label>
                <Form.Control
                  type="time"
                  name="horaInicio"
                  value={formHorario.horaInicio}
                  onChange={handleHorarioChange}
                  required
                />
              </Form.Group>
              <Form.Group className="flex-grow-1">
                <Form.Label>Hora Fim</Form.Label>
                <Form.Control
                  type="time"
                  name="horaFim"
                  value={formHorario.horaFim}
                  onChange={handleHorarioChange}
                  required
                />
              </Form.Group>
            </div>

	            <Button type="submit" variant="success" className="mt-3 w-100" style={{ backgroundColor: buttonColor, borderColor: buttonColor, color: buttonTextColor }}>
	              {formHorario.id ? "Salvar Alterações" : "Salvar Horário"}
	            </Button>
          </Form>
        </Modal.Body>
      </Modal>

      {/* 🔹 Modal Bloqueio */}
	<Modal show={showBloqueioModal} onHide={() => setShowBloqueioModal(false)} centered>
	  <Modal.Header closeButton style={{ backgroundColor: secondaryColor, color: buttonTextColor }}>
	    <Modal.Title style={{ color: buttonTextColor }}>Novo Bloqueio</Modal.Title>
	  </Modal.Header>
	  <Modal.Body style={{ backgroundColor: cardBackgroundColor, color: cardTextColor }}>
    <Form onSubmit={handleBloqueioSubmit}>
      <Form.Check
        className="mb-3"
        type="checkbox"
        label="Bloquear por dia da semana e mês (recorrente)"
        name="recorrente"
        checked={formBloqueio.recorrente || false}
        onChange={(e) =>
          setFormBloqueio((prev) => ({
            ...prev,
            recorrente: e.target.checked,
          }))
        }
      />

      {!formBloqueio.recorrente ? (
        <>
          <div className="d-flex gap-3">
            <Form.Group className="flex-grow-1">
              <Form.Label>Data Início</Form.Label>
              <Form.Control
                type="date"
                name="dataInicio"
                value={formBloqueio.dataInicio}
                onChange={handleBloqueioChange}
                required
              />
            </Form.Group>
            <Form.Group className="flex-grow-1">
              <Form.Label>Data Fim (opcional)</Form.Label>
              <Form.Control
                type="date"
                name="dataFim"
                value={formBloqueio.dataFim}
                onChange={handleBloqueioChange}
              />
            </Form.Group>
          </div>
        </>
      ) : (
        <>
          <div className="d-flex gap-3">
            <Form.Group className="flex-grow-1">
              <Form.Label>Mês</Form.Label>
              <Form.Select
                name="mes"
                value={formBloqueio.mes || ""}
                onChange={handleBloqueioChange}
                required
              >
                <option value="">Selecione...</option>
                {Array.from({ length: 12 }).map((_, i) => (
                  <option key={i + 1} value={i + 1}>
                    {new Date(0, i).toLocaleString("pt-BR", { month: "long" })}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group className="flex-grow-1">
              <Form.Label>Dia da Semana</Form.Label>
              <Form.Select
                name="diaSemana"
                value={formBloqueio.diaSemana || ""}
                onChange={handleBloqueioChange}
                required
              >
                <option value="">Selecione...</option>
                {diasSemana.map((d, i) => (
                  <option key={i} value={i}>
                    {d}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </div>
        </>
      )}

      <Form.Check
        className="mt-3"
        type="checkbox"
        label="Bloquear o dia todo"
        name="diaTodo"
        checked={formBloqueio.diaTodo}
        onChange={handleBloqueioChange}
      />

      {!formBloqueio.diaTodo && (
        <div className="d-flex gap-3 mt-3">
          <Form.Group className="flex-grow-1">
            <Form.Label>Hora Início</Form.Label>
            <Form.Control
              type="time"
              name="horaInicio"
              value={formBloqueio.horaInicio}
              onChange={handleBloqueioChange}
              required
            />
          </Form.Group>
          <Form.Group className="flex-grow-1">
            <Form.Label>Hora Fim</Form.Label>
            <Form.Control
              type="time"
              name="horaFim"
              value={formBloqueio.horaFim}
              onChange={handleBloqueioChange}
              required
            />
          </Form.Group>
        </div>
      )}

	      <Button type="submit" variant="warning" className="mt-3 w-100" style={{ backgroundColor: secondaryColor, borderColor: secondaryColor, color: buttonTextColor }}>
	        Salvar Bloqueio
	      </Button>
    </Form>
  </Modal.Body>
</Modal>
    </div>
  );
}
